import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGovernment: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGovernment"><Path d="M15 12V20" stroke="currentColor"/><Path d="M9 12V20" stroke="currentColor"/><Path d="M3.5 20.5V12.75C3.5 8.05558 7.30558 4.25 12 4.25C16.6944 4.25 20.5 8.05558 20.5 12.75V20.5" stroke="currentColor"/><Path d="M12 4.5V0.5H14.5V2.5H12" stroke="currentColor"/><Path d="M2 20.5H22" stroke="currentColor"/><Path d="M2 11.5H22" stroke="currentColor"/></CentralIconBase>;
});

export default IconGovernment;
